<template>
	<div class="m-4">
		<rp-spinner></rp-spinner>

		<div class="mt-4 mb-4">
			<rp-button class="mr-4" disabled>Disabled</rp-button>
			<rp-button class="mr-4" :disabled="spinner" @click="spin">
				<rp-spinner v-if="spinner"></rp-spinner>
				<p v-else>Spinner</p>
			</rp-button>
			<rp-button>Hi!</rp-button>
		</div>
		<!-- Cards -->
		<rp-card class="w-full p-4" horizontal>
			<template #header>
				<div class="flex flex-col items-center mr-4">
					<img
						class="h-40 mb-2"
						src="https://images-na.ssl-images-amazon.com/images/I/51GZ9eiK1FL._SX195_.jpg"
						alt=""
					/>
					<div class="flex">
						<img
							class="h-12 mr-2"
							src="https://images-na.ssl-images-amazon.com/images/I/51GZ9eiK1FL._SX195_.jpg"
							alt=""
							@click="showModal(1)"
						/>
						<img
							class="h-12 mr-2"
							src="https://images-na.ssl-images-amazon.com/images/I/51GZ9eiK1FL._SX195_.jpg"
							alt=""
							@click="showModal(2)"
						/>
						<img
							class="h-12 mr-2"
							src="https://images-na.ssl-images-amazon.com/images/I/51GZ9eiK1FL._SX195_.jpg"
							alt=""
							@click="showModal(3)"
						/>
					</div>
				</div>
			</template>
			<div>
				<h1 class="text-xl">Boogy & Rana - Tome 1</h1>
				<h2 class="text-sm text-gray-600 mb-2">BD</h2>
				<p class="text-md text-gray-800">
					Longue description samer. Longue description samer. Longue description
					samer. Longue description samer. Longue description samer. Longue
					description samer. Longue description samer. Longue description samer.
				</p>
			</div>
			<template #footer>
				<div class="flex justify-between items-center">
					<RpAddRemoveInput class="mr-8" v-model="quantity" />
					<span class="text-xl">{{ price * quantity }}e</span>
					<rp-button class="ml-12 mr-4">Ajouter</rp-button>
				</div>
			</template>
		</rp-card>

		<rp-card class="mt-2 mb-2 w-40">
			<template #header>
				<div class="flex justify-between items-center mb-2">
					<span class="text-lg">Total</span>
					<span class="text-2xl">{{ price * quantity }}e</span>
				</div>
			</template>
			<rp-button>Payer</rp-button>
		</rp-card>

		<RpAddRemoveInput v-model="quantity" />
		{{ quantity }}

		<!-- Modal -->
		<rp-button @click="isModalVisible = true">Show modal</rp-button>
		<rp-modal v-if="isModalVisible" @close="isModalVisible = false"></rp-modal>

		<!-- Nav -->
		<rp-nav pageName="Dashboard" class="mt-4"></rp-nav>
	</div>
</template>

<script>
import RpButton from "../components/RpButton";
import RpCard from "../components/RpCard";
import RpAddRemoveInput from "../components/RpAddRemoveInput";
import RpModal from "../components/RpModal";
import RpNav from "../components/RpNav";
import RpSpinner from "../components/RpSpinner";

export default {
	name: "Playground",
	components: {
		RpButton,
		RpCard,
		RpAddRemoveInput,
		RpModal,
		RpNav,
		RpSpinner,
	},
	data() {
		return {
			isModalVisible: false,
			quantity: 1,
			price: 15,
			spinner: false,
		};
	},
	methods: {
		showModal(key) {
			console.log(key);
		},
		spin() {
			this.spinner = true;
			setTimeout(() => {
				this.spinner = false;
			}, 2000);
		},
	},
};
</script>

<style></style>
